import { render, staticRenderFns } from "./SetDateConfig.vue?vue&type=template&id=7dd869e2&scoped=true"
import script from "./SetDateConfig.vue?vue&type=script&lang=js"
export * from "./SetDateConfig.vue?vue&type=script&lang=js"
import style0 from "./SetDateConfig.vue?vue&type=style&index=0&id=7dd869e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd869e2",
  null
  
)

export default component.exports